<template>
  <div>
    <label for="empresa_tienda" class="label">{{ I18n.tienda }}:</label>
    <div class="field has-addons">
      <p class="control">
        <a class="button is-static">agilpedido.com/</a>
      </p>
      <div class="control">
        <input
          v-model="tienda.tienda"
          @change="tiendaDirty = true"
          :class="{ 'is-danger': tiendaDirty && !tiendaValida }"
          ref="tienda"
          id="empresa_tienda"
          class="input"
          type="text"
          maxlength="30"
        />
      </div>
    </div>
    <p class="help">
      {{ I18n.tienda_ayuda }}
    </p>

    <div class="field">
      <label for="nombre" class="label">{{ I18n.nombre }}:</label>
      <div class="control">
        <input
          v-model="tienda.nombre"
          @change="nombreDirty = true"
          :class="{ 'is-danger': nombreDirty && !nombreValido }"
          id="nombre"
          class="input"
          type="text"
          maxlength="50"
        />
      </div>
      <p class="help">
        {{ I18n.nombre_ayuda }}
      </p>
    </div>

    <label for="tienda_whatsapp" class="label">{{ I18n.whatsapp }}:</label>
    <div class="field has-addons">
      <p class="control">
        <a class="button is-static">
          <span class="flag-icon" :class="banderaPais"></span>
          {{ prefijoPais }}
        </a>
      </p>
      <div class="control">
        <input
          v-model="whatsAppSinPrefijo"
          @change="whatsappDirty = true"
          :class="{ 'is-danger': whatsappDirty && !whatsappValido }"
          id="tienda_whatsapp"
          class="input"
          type="text"
          maxlength="15"
        />
      </div>
    </div>
    <p class="help">
      {{ I18n.whatsapp_ayuda }}
    </p>

    <div class="field">
      <label for="localidad" class="label">{{ I18n.localidad }}:</label>
      <div class="control">
        <input
          v-model="tienda.localidad"
          id="localidad"
          class="input"
          type="text"
          required
          maxlength="30"
        />
      </div>
    </div>

    <div class="field">
      <label for="tienda_costo_envio" class="label">{{ I18n.costo_envio }}:</label>
      <div class="control">
        <input
          v-model="tienda.costo_envio"
          @change="costoEnvioDirty = true"
          :class="{ 'is-danger': costoEnvioDirty && !costoEnvioValido }"
          id="tienda_costo_envio"
          class="input"
          type="number"
        />
      </div>
      <p class="help">
        {{ I18n.costo_envio_ayuda }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tienda: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      whatsAppSinPrefijo: '',
      tiendaDirty: false,
      nombreDirty: false,
      whatsappDirty: false,
      localidadDirty: false,
      costoEnvioDirty: false,
      I18n: serverExports.I18n
    }
  },

  created() {
    this.$emit('updateValida', this.valida)
  },

  mounted() {
    this.$refs.tienda.focus()
  },

  computed: {
    banderaPais() {
      return `flag-icon-${serverExports.pais}`
    },

    prefijoPais() {
      return serverExports.prefijo
    },

    tiendaValida() {
      return /^[a-zA-Z0-9\-\_]+$/.test(this.tienda.tienda)
    },

    nombreValido() {
      return !!this.tienda.nombre.length
    },

    whatsappValido() {
      return /^\d{5,15}$/.test(this.whatsAppSinPrefijo)
    },

    localidadValida() {
      return !!this.tienda.localidad.length
    },

    costoEnvioValido() {
      return /^\d+$/.test(this.tienda.costo_envio)
    },

    valida() {
      return (
        this.tiendaValida &&
        this.nombreValido &&
        this.whatsappValido &&
        this.localidadValida &&
        this.costoEnvioValido
      )
    }
  },

  watch: {
    whatsAppSinPrefijo(value) {
      this.tienda.whatsapp = serverExports.prefijo + value
    },

    valida(newValue) {
      this.$emit('updateValida', newValue)
    }
  }
}
</script>

<style scoped>
.has-addons + p.help {
  margin-top: -0.5rem;
  margin-bottom: 0.75rem;
}

.flag-icon {
  margin-right: 0.5rem;
}
</style>
